import styled from 'styled-components';
import { rem } from '../../utils/Polished';
import TooltipBase from './TooltipBaseSC';
export default styled(TooltipBase) `
  border: none;
  background: ${(p) => p.theme.ColorBackgroundTooltipText};
  box-shadow: ${(p) => p.theme.SizeShadowTooltipText}
    ${(p) => p.theme.ColorShadowTooltipText};
  color: ${(p) => p.theme.ColorFontTooltipText};

  ._ndsTooltip__content {
    padding: ${rem('4px')} ${rem('8px')};
    background-color: ${(p) => p.theme.ColorBackgroundTooltipText};
  }

  ._ndsTooltip__arrow {
    width: ${rem('8px')};
    height: ${rem('8px')};
    background: ${(p) => p.theme.ColorBackgroundTooltipText};
    box-shadow: ${(p) => p.theme.SizeShadowTooltipText}
      ${(p) => p.theme.ColorShadowTooltipText};
  }

  &[data-placement*='top'] ._ndsTooltip__arrow {
    margin-bottom: ${rem('-4px')};
  }

  &[data-placement*='right'] ._ndsTooltip__arrow {
    margin-left: ${rem('-4px')};
  }

  &[data-placement*='bottom'] ._ndsTooltip__arrow {
    margin-top: ${rem('-4px')};
  }

  &[data-placement*='left'] ._ndsTooltip__arrow {
    margin-right: ${rem('-4px')};
  }
`;
//# sourceMappingURL=TooltipTextSC.js.map